import React, { FunctionComponent } from "react";
import { IconButton, IconButtonProps } from "@mui/material";
import IcIcon from "../../../IcIcon";

const FullscreenButton: FunctionComponent<IconButtonProps> = (props) => {
  return (
    <>
      <IconButton {...props}>
        <IcIcon icon="ic:round-fullscreen" />
      </IconButton>
    </>
  );
};

export default FullscreenButton;
